if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.location_errorHeader = "<span class='location-header'>Different Store Location</span>";
        this.right_arrow = `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
      </path></svg>`;
        this.location_errorCTA = `<a href='/cart'>Complete Purchase ${this.right_arrow}</a>`;
        this.location_errorContent = `<p>Please finish your purchase from {store} store before adding items from another store. ${this.location_errorCTA }</p>`;
        this.location_errorMessage =  `<div class='location-error'>${this.location_errorHeader}${this.location_errorContent}</div>`;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if (this.checkLocation()) this.submitButton.removeAttribute('disabled');
      }

      checkLocation () {
        let location_cookie = this.getCookie('location-restriction');
        let form_locations =  this.submitButton.getAttribute('data-locations');
        
        if (location_cookie == '') {
          if (form_locations != undefined) {
            this.locations = form_locations;
          } else {
            this.locations= '';
          }
          return true
        } else if (this.submitButton.classList.contains('not-available') || form_locations == undefined) {
          this.locations = location_cookie;
          return false;
        }
        let locations = location_cookie.split(',');
        form_locations = form_locations.split(',');
        let allowed_locations = locations.filter(location => form_locations.includes(location.trim()));
        if (allowed_locations.length > 0) {
          this.locations = allowed_locations.join(',');
          return true
        } else {
          this.locations = location_cookie;
          return false
        }
      }

      updateLocationValues() {
        console.log(this.locationDataJSON)
        if (this.locationDataJSON.variants[`${this.currentVariant}`] != undefined) {
          var availableLocations = [];
          for (const [l_key, l_value] of Object.entries(this.locationDataJSON.variants[this.currentVariant].available_locations)) {
            if (parseInt(l_value) > 0 && !availableLocations.includes(l_key)) {
              availableLocations.push(l_key.replace('ReStore', '').trim());
            }
          }
          this.submitButton.dataset.locations = availableLocations.join(',');
          console.log(availableLocations)
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log("Add")
        this.currentVariant = this.querySelector('.product-variant-id').value;
        console.log(this.locationData)
        this.locationData = this.querySelector('[location-data]');
        if (this.locationData != undefined) {
          this.locationDataJSON = JSON.parse(this.locationData.textContent);
          this.updateLocationValues();
        }

        if (!this.checkLocation()) {
          console.log(this.locations)
          this.handleErrorMessage(this.location_errorMessage.replace('{store}', this.locations.replace('ReStore', '')));
          return
        };
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.setCookie('location-restriction', this.locations, 14);
         // Check all other product forms
        let _this = this;
        let all_product_forms = document.querySelectorAll('product-form');
        all_product_forms.forEach(function(product_form) {
            let submitButton = product_form.querySelector('[type="submit"]');
            let form_locations =  submitButton.getAttribute('data-locations');
            if (form_locations != undefined) {
              form_locations = form_locations.split(',')
              let allowed_locations = _this.locations.split(',').filter(location => form_locations.includes(location.trim()));
              // if (allowed_locations.length > 0 && !submitButton.classList.contains('not-available')) {
              //   submitButton.removeAttribute('disabled');
              // } else {
              //   submitButton.setAttribute('disabled', true)
              // }
            }
        })

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000)); //exdays*60*1000 if minutes
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
  
      getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
